import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import FormLabel from "@material-ui/core/FormLabel";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
//import FormHelperText from "@material-ui/core/FormHelperText";
import Checkbox from "@material-ui/core/Checkbox";
import Dialog from "./Dialog";

import { updateService } from "../../actions";
import { connect } from "react-redux";

const styles = (theme) => ({
	root: {
		display: "flex"
	},
	formControl: {
		margin: 0
	},
	paper: {
		width: "80%",
		maxHeight: 435
	},
	body2: {
		lineHeight: 1
	}
});

const warningStyle = {
	color: "tomato",
	fontFamily: "Arial, Tahoma, sans-serif",
	letterSpacing: "2px",
	margin: "15px 0"
};

class CheckboxesGroup extends React.Component {
	state = {
		open: false,
		activeName: null,
		langBase: this.props.langBase,
		noPermission: <div style={warningStyle}>{this.props.langBase.warning}</div>
	};

	componentDidMount() {
		const services =
			(!this.props.services.responseCode && {
				...this.props.services.reduce((obj, el, index) => {
					obj[el.name] = {
						checked: el.checked,
						value: el.value,
						tasks: el.tasks
					};
					return obj;
				}, {})
			}) ||
			{};
		!this.props.services.responseCode &&
			this.setState((prevState) => {
				return {
					...prevState,
					noPermission: null,
					...services
				};
			});
	}

	handleChange = (name) => (event) => {
		const value = event.target.checked;

		this.props.updateService({ name: name, checked: value, value: null });

		//console.log(value);

		//value && this.handleClickListItem();
		this.setState(
			(prevState, props) => ({
				[name]: { ...prevState[name], checked: value },
				activeName: name
			}),
			() => {
				if (this.state[name].checked && this.state[name].tasks) {
					//console.log("tasks", this.state[name].tasks);
					this.handleClickListItem();
				} else {
					this.setState((prevState, props) => ({
						[name]: { ...prevState[name], value: null },
						activeName: null
					}));
				}
			}
		);
	};

	handleClickListItem = () => {
		this.setState({ open: true });
	};

	handleClose = (value, name, flag) => {
		this.setState((prevState, props) => ({
			[name]: {
				...prevState[name],
				value: value || null,
				checked: flag === "cancel" ? false : true
			},
			open: false,
			activeName: null
		}));

		if (flag === "cancel") {
			this.props.updateService({ name, checked: false, value: null });
		} else {
			this.props.updateService({ name, value });
		}
	};

	render() {
		const { classes, services, langBase } = this.props;
		const { mainTitle, noPermission, activeName, open } = this.state;

		return (
			<div className={classes.root}>
				<FormControl component="fieldset" className={classes.formControl}>
					<FormLabel component="legend">{mainTitle}</FormLabel>
					{noPermission || (
						<FormGroup>
							{services.map((el, i) => {
								return (
									<FormControlLabel
										key={`${i}_${el.name}`}
										control={
											<Checkbox
												checked={el.checked}
												onChange={this.handleChange(el.name)}
												value={el.name}
											/>
										}
										label={langBase.il9n[el.name]}>
										info
									</FormControlLabel>
								);
							})}
						</FormGroup>
					)}
					{activeName &&
					this.state[activeName].tasks && (
						<Dialog
							classes={{
								paper: classes.paper
							}}
							open={open}
							onClose={this.handleClose}
							activename={activeName}
							title={langBase.il9n[activeName]}
							options={(this.state[activeName] && this.state[activeName].tasks) || undefined}
						/>
					)}
				</FormControl>
			</div>
		);
	}
}

CheckboxesGroup.propTypes = {
	classes: PropTypes.object.isRequired,
	//title: PropTypes.string.isRequired,
	services: PropTypes.array.isRequired
};

const mapStateToProps = (state) => ({
	langBase: state.langBase,
	services: state.services
});

const mapDispatchToProps = {
	updateService
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(CheckboxesGroup));

//export default withStyles(styles)(CheckboxesGroup);
